import _ from "lodash";
import React from "react";
import { Check2Square } from 'react-bootstrap-icons';

function FlexiGridCheckboxComponent(props) {
	const { schema, idSchema, onChange, formData, required, disabled } = props;
	const title = schema.title;
	const properties = schema.properties;
	const propertyKeys = Object.keys(properties);
	let data = _.clone(formData);

	function renderDisabledCheckboxes() {
		return (
			<React.Fragment>
				{
					propertyKeys.map((key, i) => {
						let id = idSchema[key]['$id'];
						let type = properties[key].type;

						if (type !== 'boolean' || !formData[key]) return null;

						return (
							<div className="form-check form-check-inline" key={id}>
								<Check2Square className="readonly-checkbox" />
								<label className="form-check-label" htmlFor={id}>{properties[key].title}</label>
							</div>
						)
					})
				}
			</React.Fragment>
		)
	}

	function CheckboxElement({ id, fieldId, properties }) {
		return (
			<div className="form-check form-check-inline" key={id}>
				<input
					id={id}
					className="form-check-input"
					type="checkbox"
					checked={formData[fieldId]}
					disabled={disabled}
					onChange={(e) => {
						_.assign(data, {
							[fieldId]: e.target.checked
						});

						onChange(data);
					}} />
				<label className="form-check-label" htmlFor={id}>{properties[fieldId].title}</label>
			</div>
		)
	}

	function TextareaElement({ id, fieldId, properties }) {
		return (
			<div className="row" style={{ "margin": "10px 0px" }} key={id}>
				<div className="col-12 p-0">
					<div className="form-group">
						<div className="therapist-notes">
							<label htmlFor={id}>{properties[fieldId].title}</label>
							<div className="input-group">
								<textarea
									id={id}
									placeholder=""
									rows="5"
									className="form-control"
									defaultValue={formData[fieldId]}
									onBlur={(e) => {
										if (e.target.value) {
											_.assign(data, {
												[fieldId]: e.target.value
											});
										} else {
											_.assign(data, _.filter(data, function(value, key) {
												return key !== fieldId
											}))
										}

										onChange(data);
									}}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}

	function TextInput({ id, fieldId, properties }) {
		return (
			<div className="row" style={{ "margin": "10px 0px" }} key={id}>
				<div className="col-12 p-0">
					<div className="form-group">
						<label htmlFor={id}>{properties[fieldId].title}</label>
						<div className="input-group">
							<input
								id={id}
								placeholder=""
								rows="5"
								className="form-control"
								defaultValue={formData[fieldId]}
								onBlur={(e) => {
									_.assign(data, {
										[fieldId]: e.target.value
									});

									onChange(data);
								}}
							/>
						</div>
					</div>
				</div>
			</div>
		)
	}

	function renderElements() {
		let children = [];

		propertyKeys.map((key) => {
			let id = idSchema[key]['$id'];
			let type = properties[key].type;
			let widget = properties[key].widget;

			if (type === 'boolean') {
				children.push(<CheckboxElement {...{ id, fieldId: key, properties }} key={key} />);
			} else if (widget === 'textarea') {
				children.push(<TextareaElement {...{ id, fieldId: key, properties }} key={key} />);
			} else if (type === 'string') {
				children.push(<TextInput {...{ id, fieldId: key, properties }} key={key} />);
			}
		})

		return (
			<React.Fragment>
				{children}
			</React.Fragment>
		)
	}

	return (
		<React.Fragment>
			<label>{title}{required && "*"}</label>
			<div className="p-0 container-fluid flexi-grid-checkboxes">
				{disabled ? renderDisabledCheckboxes() : renderElements()}
			</div>
		</React.Fragment>
	)
}

export default FlexiGridCheckboxComponent;